import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ControlledFeatureService from 'services/ControlledFeatureService';
import { selector as userSelector } from 'pages/User/State';
import LinkSwitch from 'components/LinkSwitch/LinkSwitch';
import allUserGroups from 'enum/userGroups';


function ProfileLinkSwitch(props) {
  const isClassicLink = ControlledFeatureService.setUser(props.user).has(allUserGroups.PROFILE_V2_NOT_SINGLE_PAGE_APP);

  const {
    children,
    settings,
    user,
    ...restProps
  } = props;

  return (
    <LinkSwitch isRouterLink={!isClassicLink} {...restProps}>
      {children}
    </LinkSwitch>
  );
}

ProfileLinkSwitch.propTypes = {
  user: PropTypes.object.isRequired,
  children: PropTypes.node,
  settings: PropTypes.object,
};

ProfileLinkSwitch.defaultProps = {
  children: null,
  settings: undefined,
};

export default connect(userSelector)(ProfileLinkSwitch);
